import { useTranslation } from 'react-i18next';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';
import { IMPRINT_IMAGE_SRC, IMPRINT_ROW_IDS } from '../data/imprintContent';

/**
 * Künye (yasal / yayın bilgileri) — URL: /imprint
 */
export function ImprintPage() {
    const { t } = useTranslation();

    return (
        <>
            <PageSeo
                title={`${t('imprint.title')} — ${t('header.rotaryAlt')}`}
                description={t('seo.imprint')}
            />
            <SubpageLayout
                title={t('imprint.title')}
                subtitle={t('imprint.subtitle')}
                contentClassName="imprint-page"
            >
            <div className="row g-4 g-xl-5 align-items-start">
                <div className="col-lg-7">
                    <figure className="imprint-figure mb-0">
                        <img
                            src={IMPRINT_IMAGE_SRC}
                            alt={t('imprint.imageAlt')}
                            className="imprint-visual-img"
                            loading="lazy"
                            decoding="async"
                        />
                    </figure>
                </div>
                <div className="col-lg-5">
                    <div className="imprint-details">
                        <h2 className="imprint-details-heading h4 mb-0">
                            {t('imprint.officialHeading')}
                        </h2>
                        <p className="imprint-details-lead small text-secondary mb-0 mt-3">
                            {t('imprint.lead')}
                        </p>
                        <dl className="imprint-details-list mb-0">
                            {IMPRINT_ROW_IDS.map((id) => (
                                <div key={id} className="imprint-detail-row">
                                    <dt className="imprint-detail-label">
                                        {t(`imprint.rows.${id}.label`)}
                                    </dt>
                                    <dd className="imprint-detail-value">
                                        {t(`imprint.rows.${id}.value`)}
                                    </dd>
                                </div>
                            ))}
                        </dl>
                    </div>
                </div>
            </div>
        </SubpageLayout>
        </>
    );
}
